<section class="container-section" *ngIf="!isOpened">
  <div class="row">
    <div class="col-12 col-sm-12">
      <form class="needs-validation container-style" novalidate [formGroup]="formCashReceipt">
        <div class="ps-2 pe-2">
          <div class="row pt-1">
            <div class="col">
              <app-custom-button [title]="'Regresar'" [icon]="'pi pi-arrow-left'" [link]="true" [label]="'Regresar'"
                [width]="'6rem'" [routerLink]='isChargeAccount ? "/cash-receipt-charge-account" : "/cash-receipt"'
                [severity]="null"></app-custom-button>
            </div>
            <div class="col d-flex justify-content-sm-center justify-content-end align-items-center">
              <app-navigation (buttonClick)="getButtonClick($event)"></app-navigation>
            </div>

            <div class="col mt-2 mt-sm-0 gap-1 d-flex justify-content-md-end justify-content-center">
              <app-custom-modal #printingRangeModal [title]="'Imprimir'" [icon]="'pi pi-print'"
                [header]="'Parámetros de Impresión'" [inputs$]="inputsForPrintingRangeModals$"
                [children]="componentPrintingRangeModal" [closable]="false" [width]="'30vw'"
                (params)="getPrintCashReceiptsByRange($event)" hidden>
              </app-custom-modal>
              <app-custom-button *ngIf="cashReceiptContract.cashReceiptId !== 0" [title]="'Imprimir'"
                [severity]="'contrast'" [icon]="'pi pi-print'" (onClick)="openPrintingRangeModal()">
              </app-custom-button>
              <app-custom-button [title]="'Eliminar'" [severity]="'contrast'" [icon]="'pi pi-trash'"
                (onClick)="deleteCashReceipt()"></app-custom-button>

              <app-custom-button class="ms-2" [title]="'Nuevo'" [label]="'Nuevo'" [icon]="'pi pi-plus'"
                [width]="'5.5rem'" [severity]="'success'" [variant]="undefined"
                (onClick)="createNewCashReceipt()"></app-custom-button>
            </div>
            <hr class="my-1">
          </div>
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-12">
              <app-custom-audit-info [userNameCreate]="cashReceiptContract.userNameCreate"
                [createDate]="cashReceiptContract.createDate" [userNameUpdate]="cashReceiptContract.userNameUpdate"
                [updateDate]="cashReceiptContract.updateDate"
                [reserveSpace]="true"></app-custom-audit-info>
            </div>
          </div>
          <div class="row px-0 mx-0">
            <div class="row px-0 mx-0">
              <div class="row px-0 mx-0">
                <div class="col col-sm-auto field-branch">
                  <app-custom-select formControlName="branchId" [labelText]="'Sucursal'" [list]="listBranch"
                    [required]="true" [recovery]="true" (onChangeSelect)="changeBranch($event, false)">
                  </app-custom-select>
                </div>
                <div class="col col-sm-auto field-enterprise">
                  <app-custom-select formControlName="enterpriseId" [labelText]="'Empresa'" [list]="listEnterprise"
                    [required]="true" [recovery]="true" (onChangeSelect)="changeEnterprise($event)">
                  </app-custom-select>
                </div>
                <div class="col field-consecutive">
                  <app-custom-input-number formControlName="consecutive" [labelText]="'Número'" [required]="true"
                    [recovery]="true" (onChangeNumber)="changeConsecutive()"></app-custom-input-number>
                </div>
                <div class="col field-alter-number">
                  <app-custom-input-text formControlName="alterNumber" [labelText]="'Nro.Alt.'"></app-custom-input-text>
                </div>
                <div class="col field-date-cash-receipt">
                  <app-custom-datepicker formControlName="dateCashReceipt" [labelText]="'Fecha'"
                    [required]="true"></app-custom-datepicker>
                </div>
                <div class="col field-state">
                  <app-custom-tag [label]="'Estado'" [value]="cashReceiptStateString"
                    [severity]="cashReceiptContract.cashReceiptStateId === cashReceiptStateOpen ? 'danger' : ''">
                  </app-custom-tag>
                </div>
                <div class="col field-change-states d-flex align-items-end gap-1 mt-2">
                  <app-custom-button [icon]="iconStateCashReceipt" [title]="titleStateCashReceipt"
                    [severity]="'primary'" (onClick)="changeCashReceiptState()"></app-custom-button>
                  <app-custom-button [title]="'Anular'" [icon]="'pi pi-ban'" [severity]="'warn'"
                    (onClick)="annulDevolution()"></app-custom-button>

                  <app-custom-chip class="ms-2" [label]="'Interfaz: ' + accountingInterfaceCode" />
                </div>
              </div>
              <div class="row px-0 mx-0">
                <div class="col field-income-concept">
                  <app-custom-select formControlName="incomeConceptId" [labelText]="'Concepto Ingreso'"
                    [list]="listIncomeConcept" [required]="true" (onChangeSelect)="getIncomeConcept($event)">
                  </app-custom-select>
                </div>
                <div class="col field-client">
                  <app-custom-autocomplete formControlName="clientId" [labelText]="'Cliente'" [list]="listClient"
                    [required]="true" [class]="stateClientId === 1 ? '' : 'text-danger'"
                    (onChangeSelect)="getClient($event)">
                  </app-custom-autocomplete>
                </div>
                <div class="col field-total-value">
                  <app-custom-input-decimal formControlName="totalValue"
                    [labelText]="'Vr.Ingreso'"></app-custom-input-decimal>
                </div>
                <div class="col field-other-values">
                  <app-custom-input-decimal formControlName="otherValues"
                    [labelText]="'Otros Valores'"></app-custom-input-decimal>
                </div>
              </div>
              <div class="row px-0 mx-0">
                <div class="col field-refund-value">
                  <app-custom-input-decimal formControlName="refundValue"
                    [labelText]="'Vr.Reembolso'"></app-custom-input-decimal>
                </div>
                <div class="col field-utilization-value">
                  <app-custom-input-decimal formControlName="utilizationValue"
                    [labelText]="'Vr.Aprove/to.'"></app-custom-input-decimal>
                </div>
                <div class="col field-interest-value">
                  <app-custom-input-decimal formControlName="interestValue"
                    [labelText]="'Vr.Intereses'"></app-custom-input-decimal>
                </div>
                <div class="col field-commission-value">
                  <app-custom-input-decimal formControlName="commissionValue"
                    [labelText]="'Vr.Comisión'"></app-custom-input-decimal>
                </div>
                <div class="col field-date-date-payment">
                  <app-custom-datepicker formControlName="datePayment"
                    [labelText]="'Fecha Pago TRM'"></app-custom-datepicker>
                </div>
                <div class="col field-currency">
                  <app-custom-input-text [value]="codeCurrency" [labelText]="'Moneda'"
                    [inputClass]="codeCurrency != 'COP' ? 'text-danger' : ''" [disabled]="true">
                  </app-custom-input-text>
                </div>
                <div class="col field-trm">
                  <app-custom-input-decimal
                    [value]="cashReceiptContract.currencyExchange != null ? cashReceiptContract.currencyExchange.valueExchange: 0"
                    [labelText]="'TRM'" [disabled]="true">
                  </app-custom-input-decimal>
                </div>
              </div>
              <div class="row px-0 mx-0">
                <div class="col-lg-5 col-md-5 col-sm-6 col-12">
                  <app-custom-textarea formControlName="description" [labelText]="'Descripción'" [rows]="1"
                    [maxLength]="320"></app-custom-textarea>
                </div>
                <div class="col-lg-5 col-md-5 col-sm-6 col-12">
                  <app-custom-textarea formControlName="observation" [labelText]="'Observación'" [rows]="1"
                    [maxLength]="250"></app-custom-textarea>
                </div>
                <div
                  class="col-lg-1 col-md-1 col-sm-12 save-button d-flex justify-content-end justify-content-md-start align-items-end mt-2">
                  <app-custom-button [label]="'Guardar'" [severity]="'primary'" [variant]="undefined"
                    [disabled]="disabledForm" (onClick)="send()">
                  </app-custom-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="col-lg-12 col-md-12 col-sm-12 col-12" [hidden]="!visibleSelectInvoice">
    <p-accordion value="none" class="accordion-detail" [transitionOptions]="'0ms'"
      (onClose)="showAccordionDetail = !showAccordionDetail" (onOpen)="showAccordionDetail = !showAccordionDetail">
      <p-accordion-panel value="0">
        <p-accordion-header>Detalle del recibo de caja ({{quantityDetails}})</p-accordion-header>
        <p-accordion-content [hidden]="!showAccordionDetail">
          <div class="row detail-container">
            <div class="col-lg-12 col-md-12 col-sm-12 col-12">
              <app-invoice-cash-receipt [cashReceiptModel]="cashReceiptContract"
                [permissionUpdatable]="permissionUpdatable" [isChargeAccount]="isChargeAccount"
                [disabledDetail]="disabledDetail" (quantityDetails)="quantityDetails = $event">
              </app-invoice-cash-receipt>
            </div>
          </div>
        </p-accordion-content>
      </p-accordion-panel>
    </p-accordion>
  </div>
  <div class="row">
    <div class="col-lg-6 col-md-6 col-sm-12 col-12">
      <p-accordion value="none" class="accordion-detail" [transitionOptions]="'0ms'"
        (onClose)="showAccordionPayment = !showAccordionPayment"
        (onOpen)="showAccordionPayment = !showAccordionPayment">
        <p-accordion-panel value="0">
          <p-accordion-header>Formas de pago de este recibo ({{quantityPayments}})</p-accordion-header>
          <p-accordion-content [hidden]="!showAccordionPayment">
            <div class="row detail-container">
              <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                <app-cash-receipt-payment [cashReceiptModel]="cashReceiptContract" [updatePayments]="updateAdvances"
                  [permissionUpdatable]="permissionUpdatable" [disabledDetail]="disabledDetail"
                  (quantityDetails)="quantityPayments = $event" (updateCashReceipt)="getCashReceiptById()">
                </app-cash-receipt-payment>
              </div>
            </div>
          </p-accordion-content>
        </p-accordion-panel>
      </p-accordion>
    </div>
    <div class="col-lg-6 col-md-6 col-sm-12 col-12" [hidden]="!visibleSelectInvoice">
      <p-accordion value="none" class="accordion-detail" [transitionOptions]="'0ms'"
        (onClose)="showAccordionAdvancePayments = !showAccordionAdvancePayments"
        (onOpen)="showAccordionAdvancePayments = !showAccordionAdvancePayments">
        <p-accordion-panel value="0">
          <p-accordion-header>Anticipos aplicados en este recibo ({{quantityAdvancePayments}})</p-accordion-header>
          <p-accordion-content [hidden]="!showAccordionAdvancePayments">
            <div class="row detail-container">
              <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                <app-advance-payments-applied [cashReceiptModel]="cashReceiptContract"
                  [permissionUpdatable]="permissionUpdatable" [disabledDetail]="disabledDetail"
                  (quantityDetails)="quantityAdvancePayments = $event"
                  (updateAdvances)="updateAdvances = !updateAdvances"></app-advance-payments-applied>
              </div>
            </div>
          </p-accordion-content>
        </p-accordion-panel>
      </p-accordion>
    </div>
  </div>
</section>

<!-- Formato Imprimir Recibo de Caja -->
<app-print-cash-receipt id="print-cash-receipt" [companyId]="companyId" [cashReceiptModels]="cashReceiptsPrintModel"
  [focusText]="true" [editFormat]="false" (finishLoadingPrint)="finishLoading($event)"></app-print-cash-receipt>

<!-- Mensaje de duplicidad ventanas abiertas -->
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1"> highlight_off </span>
  <h6>No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>